
import axios from '../axios'

// 保存
// http://192.168.1.111:8000/addImg'
// export const addimg = (data) => {
//     return axios({
//         url: '/admin/service/sys_image_add',
//         method: 'post',
//         data
//     })
// }
// 小区
// export const addimg = (data) => {
//     return axios({
//         url: '/addImg',
//         method: 'post',
//         data
//     })
// }
// 人员
export const addimgPer = (data) => {
    return axios({
        url: '/addAvatar',
        method: 'post',
        data
    })
}
// 人员外的
export const addPicByFile = (data) => {
    return axios({
        url: '/addPicByFile',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/imgAdd.js